module.exports = __webpack_public_path__ + "img/联系我们+2_03.85d6bfd9.png";